import React, { useMemo } from 'react'
import styled from 'styled-components'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import "lightgallery.js/dist/css/lightgallery.css";
import { LightgalleryItem, LightgalleryProvider } from "react-lightgallery";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Container = styled.div`
  margin-bottom: 1rem;
  max-width: 1300px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  @media(max-width: 786px) {
    width: calc(100vw - 3rem);
    margin-bottom: 20px;
  }
  img {
    cursor: zoom-in;
    border-radius: 8px;
    max-width: 100%;
    @media(max-width: 786px) {
    }
  }
  .lg-outer .lg-thumb-item.active, .lg-outer .lg-thumb-item:hover {
    border-color: var(--pink) !important;
  }
`


const Gallery = (props) => {
  const { photos, category, year } = props;

  // Sort photos
  const sortedPhotos = useMemo(() => {
    return [...photos].sort((a, b) => b.year - a.year);
  }, [photos]);

  let colcount = 3;
  let breakpoints = { 350: 1, 750: 2, 900: 3 };

  if (sortedPhotos.length === 1) {
    colcount = 1;
    breakpoints = { 350: 1, 750: 1, 900: 1 };
  }

  if (sortedPhotos.length === 2) {
    colcount = 2;
    breakpoints = { 240: 2, 750: 2, 900: 2 };
  }

  // Prepare the data for Lightgallery
  const items = useMemo(() =>
    sortedPhotos.map(photo => ({
      src: getImage(photo.src).images.fallback.src,
      thumb: getImage(photo.src).images.fallback.src,
      downloadUrl: photo.original,
    })),
    [sortedPhotos]
  );


  return (
    <Container>
    <LightgalleryProvider
      plugins={['lg-zoom', 'lg-thumbnail']}
      dynamicEl={items}
      key={`${category}-${year}`}  // Force re-render when category or year changes
    >
        <ResponsiveMasonry columnsCountBreakPoints={breakpoints}>
          <Masonry columnsCount={colcount} gutter="16px">
            {photos.map((photo, index) => {
              const image = getImage(photo.src);
              const download_url = photo.original;
              return (
                 <LightgalleryItem
                   key={index}
                   src={image.images.fallback.src} // Use the optimized image for display
                   downloadUrl={download_url} // Use the original image for download
                 >
                   <GatsbyImage image={image} alt={`${category} ${year}`} />
                 </LightgalleryItem>
               );
            })}
          </Masonry>
        </ResponsiveMasonry>
      </LightgalleryProvider>
    </Container>
  )
}

export default Gallery
